import { mergeStyles } from '@lib/styles';

/**
 * Displays a Loading circle spinner
 * @returns
 */
export function Loading({ className }: { className?: string }) {
  return (
    <div className="flex items-center justify-center">
      <div className={mergeStyles(className ?? '', 'lds-roller')}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}

export function LoadingFlat() {
  return (
    <div className="flex max-h-[80px] min-h-10 items-center justify-center">
      <div className="relative w-[80px]">
        <div
          className="absolute left-[8px] top-[-0.4rem] h-[0.8rem] w-[0.8rem] 
        animate-[lds-ellipsis1_0.6s_infinite] rounded-full bg-orange ease-[cubic-bezier(0,1,1,0)]"
        />
        <div
          className="animate-lds-[lds-ellipsis2_0.6s_infinite] absolute left-[8px] top-[-0.4rem] h-[0.8rem]
        w-[0.8rem] rounded-full bg-orange ease-[cubic-bezier(0,1,1,0)]"
        />
        <div
          className="animate-lds-[lds-ellipsis2_0.6s_infinite] absolute left-[32px] top-[-0.4rem] h-[0.8rem]
        w-[0.8rem] rounded-full bg-orange ease-[cubic-bezier(0,1,1,0)]"
        />
        <div
          className="animate-lds-[lds-ellipsis3_0.6s_infinite] absolute left-[56px] top-[-0.4rem] h-[0.8rem]
        w-[0.8rem] rounded-full bg-orange ease-[cubic-bezier(0,1,1,0)]"
        />
      </div>
    </div>
  );
}
